export const RESULTS_TEMPLATE = [
  'Отсутствуют статистически значимые различия по всем изучаемым исходам.',
  'Статистически значимое преимущество [предлагаемый ЛП] по всем изучаемым исходам.',
  'Отсутствуют статистически значимые различия по критериям: [названия критериев].',
  'Статистически значимое преимущество [предлагаемый ЛП] по критериям: [названия критериев].',
  'Отсутствуют статистически значимые различия по критерию [название критерия].',
  'Статистически значимое преимущество [предлагаемый ЛП] по критерию [название критерия].',
]
